import React from 'react'
import InternationalizedFormattedText from '../util/internationalized-formatted-text'
import { Link as MuiLink, makeStyles } from '@material-ui/core'
import {
  GOOGLE_PRIVACY_POLICY_URL,
  GOOGLE_SERVICE_TERMS_URL,
  LINK_REL_NOOPENER,
  LINK_TARGET_BLANK,
} from './recaptcha-info-constants'

const useStyles = makeStyles((theme) => ({
  recaptchaContainer: {
    alignSelf: 'center',
    marginTop: theme.spacing(2),
    textAlign: 'center',
  },
  recaptchaText: {
    display: 'inline',
    fontSize: '0.8rem',
    marginRight: theme.spacing(0.75),
  },
}))

const RecaptchaInfo = () => {
  const classes = useStyles()

  return (
    <div className={classes.recaptchaContainer}>
      <InternationalizedFormattedText variant='body1' id='recaptchaTitle' className={classes.recaptchaText} />
      <MuiLink href={GOOGLE_PRIVACY_POLICY_URL} target={LINK_TARGET_BLANK} rel={LINK_REL_NOOPENER}>
        <InternationalizedFormattedText variant='body1' id='privacyPolicy' className={classes.recaptchaText} />
      </MuiLink>
      <InternationalizedFormattedText variant='body1' id='and' className={classes.recaptchaText} />
      <MuiLink href={GOOGLE_SERVICE_TERMS_URL} target={LINK_TARGET_BLANK} rel={LINK_REL_NOOPENER}>
        <InternationalizedFormattedText variant='body1' id='serviceTerms' className={classes.recaptchaText} />
      </MuiLink>
      <InternationalizedFormattedText variant='body1' id='google' className={classes.recaptchaText} />
    </div>
  )
}

export default RecaptchaInfo
